import { InjectionToken } from '@angular/core';

import { IDynamicComponentsModuleConfig } from './dynamic-components-module-config.interface';

export const DYNAMIC_COMPONENT_MODULES = new InjectionToken<IDynamicComponentsModuleConfig['modules']>(
  'DYNAMIC_COMPONENT_MODULES'
);
